/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaTargetGroup } from './CriteriaTargetGroup';
import {
    CriteriaTargetGroupFromJSON,
    CriteriaTargetGroupFromJSONTyped,
    CriteriaTargetGroupToJSON,
} from './CriteriaTargetGroup';

/**
 * 
 * @export
 * @interface CreateCriteriaTargets201Response
 */
export interface CreateCriteriaTargets201Response {
    /**
     * 
     * @type {CriteriaTargetGroup}
     * @memberof CreateCriteriaTargets201Response
     */
    data?: CriteriaTargetGroup;
}

/**
 * Check if a given object implements the CreateCriteriaTargets201Response interface.
 */
export function instanceOfCreateCriteriaTargets201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCriteriaTargets201ResponseFromJSON(json: any): CreateCriteriaTargets201Response {
    return CreateCriteriaTargets201ResponseFromJSONTyped(json, false);
}

export function CreateCriteriaTargets201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaTargets201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CriteriaTargetGroupFromJSON(json['data']),
    };
}

export function CreateCriteriaTargets201ResponseToJSON(value?: CreateCriteriaTargets201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CriteriaTargetGroupToJSON(value.data),
    };
}

